import React, { useState } from "react";
import { Button, Menu, MenuItem, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  CheckCircleOutline,
  Pending,
  Email,
  DisabledByDefault,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const VerificationStatusDisplayChip = ({
  status = "pending",
  statusOptions = [],
  onChange,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isDropdown = statusOptions?.length > 0 && typeof onChange === "function";

  const getStatusIcon = (s) => {
    switch (s) {
      case "verified":
        return <CheckCircleOutline fontSize="17px" sx={{ mr: 1 }} />;
      case "pending":
        return <Pending fontSize="17px" sx={{ mr: 1 }} />;
      case "rejected":
        return <DisabledByDefault fontSize="17px" sx={{ mr: 1 }} />;
      default:
        return <Email fontSize="17px" sx={{ mr: 1 }} />;
    }
  };

  const getStatusColor = (s) => {
    switch (s) {
      case "verified":
        return "#2196F3";
      case "pending":
        return "#FF9800";
      case "rejected":
        return "#F87168";
      default:
        return "#ccc";
    }
  };

  const handleClick = (e) => {
    if (isDropdown) setAnchorEl(e.currentTarget);
  };
  const handleClose = (newStatus) => {
    if (newStatus) onChange(newStatus);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        disableRipple={!isDropdown}
        variant="contained"
        onClick={handleClick}
        sx={{
          backgroundColor: getStatusColor(status),
          width: "140px",
          padding: "1px",
          color: "#172B4D",
          borderRadius: "5px",
          boxShadow: "none",
          fontFamily: "Roboto",
          letterSpacing: ".5px",
          textTransform: "capitalize",
          cursor: isDropdown ? "pointer" : "default",
          "&:hover": {
            backgroundColor: getStatusColor(status),
            boxShadow: "none",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
          {getStatusIcon(status)}
          {t(`statuses.${status}`)}
          {isDropdown && (
            <ArrowDropDownIcon sx={{ fontSize: 18, ml: 0.25 }} />
          )}
        </Box>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {statusOptions.map((option) => (
          <MenuItem
            key={option}
            onClick={() => handleClose(option)}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            {getStatusIcon(option)}
            {t(`statuses.${option}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default VerificationStatusDisplayChip;
